<template>
  <a-row class="not-resize-for-mobile">
    <a-col :sm="24" :md="24" :lg="24" :xl="10" :xxl="10">
      <a-card :bordered="false">
        <!-- 検索区域 -->
        <div class="table-page-search-wrapper">
          <!-- 捜索区域 -->
          <a-form-model layout="inline" @keyup.enter.native="searchQuery(false, false)">
            <a-row :gutter="24">
              <a-col :sm="24" :md="10" :lg="8" :xl="14" :xxl="10">
                <a-form-model-item :labelCol="{ span: 5 }" label="">
                  <a-input :placeholder="$t('disp.roleSearchCommonds.ph')" v-model="queryParam.roleName"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :xs="1" :sm="1" class="width-fit-content">
                <a-form-model-item :wrapperCol="{ span: 24 }">
                  <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                    $t('disp.btn.search')
                  }}</a-button>
                  <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>

        <!-- ボタン操作区域 -->
        <div class="table-operator">
          <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('disp.btn.add') }}</a-button>
        </div>

        <div class="ant-alert ant-alert-info div-selected-info">
          <i class="anticon anticon-info-circle ant-alert-icon"></i>
          {{ this.$t('disp.selected') }}
          <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
          {{ this.$t('disp.item') }}
          <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
        </div>

        <div>
          <a-table
            ref="table"
            tableLayout="auto"
            class="action"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
            @change="handleTableChange"
          >
            <a-table-column key="roleCode" data-index="roleCode" title="编号" align="left" />

            <a-table-column key="roleName" data-index="roleName" title="名称" align="left" />

            <a-table-column key="description" data-index="description" title="备注" align="left" />

            <a-table-column key="systemFlag" data-index="systemFlag" title="系统角色" align="center">
              <template slot-scope="text, record">
                <a-icon
                  type="check"
                  v-if="record.systemFlag"
                  style="color: var(--color-green); font-size: 13px"
                ></a-icon>
              </template>
            </a-table-column>

            <a-table-column key="entryFlag" data-index="entryFlag" title="入职可选" align="center">
              <template slot-scope="text, record">
                <a-icon
                  type="check"
                  v-if="record.entryFlag"
                  style="color: var(--color-green); font-size: 13px"
                ></a-icon>
              </template>
            </a-table-column>

            <a-table-column key="action" title="操作" align="center">
              <div slot-scope="text, record">
                <a @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a>

                <a-divider type="vertical" />

                <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('disp.btn.delete') }}</a>
                </a-popconfirm>
              </div>
            </a-table-column>
          </a-table>
        </div>

        <!-- フォーム区域 -->
        <role-modal ref="modalForm" @emit="modalFormOk"></role-modal>
      </a-card>
    </a-col>
    <a-col :sm="24" :md="24" :lg="24" :xl="14" :xxl="14">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane :tab="$t('disp.userInfo')" key="1" :forceRender="true">
          <Role-User-Info ref="RoleUserInfo"></Role-User-Info>
        </a-tab-pane>
      </a-tabs>
    </a-col>
  </a-row>
</template>
<script>
import { tableMixin } from '@/mixins/tableMixin'
import { deleteAction, postAction, getAction } from '@/api/manage'
import { filterObj } from '@/utils/util'
import RoleModal from './modules/RoleModal'
import moment from 'moment'
import RoleUserInfo from './modules/RoleUserInfo'

export default {
  name: 'RoleManage',
  mixins: [tableMixin],
  components: {
    RoleModal,
    RoleUserInfo,
    moment,
  },
  mounted() {
    this.forceClear = true
  },
  data() {
    return {
      model: {},
      currentRoleId: '',
      url: {
        list: '/blaze-sys/k00/k0003/RoleManage/listByCodeOrName',
        delete: '/blaze-sys/k00/k0003/RoleManage/delete',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows

      this.$refs.RoleUserInfo.queryParam.username = ''
      this.$refs.RoleUserInfo.onClearSelected()
      this.$refs.RoleUserInfo.open(selectionRows[0])
    },
    handlePerssion(roleId) {
      this.$refs.modalRolePermission.show(roleId)
    },
  },
  watch: {
    selectedRowKeys: function (e) {
      if (this.selectedRowKeys.length == 0) {
        this.$refs.RoleUserInfo.currentRoleId = ''
        this.$refs.RoleUserInfo.queryParam = {}
      }
    },
  },
}
</script>
<style scoped></style>
